import { isValid as cpfIsValid } from '@fnando/cpf';
import { isValid as cnpjIsValid } from '@fnando/cnpj';
import React from 'react';
import { T } from 'shared/helper/translate';
import { Controls, validators } from 'shared/helper/form';
var notEmpty = validators.notEmpty;
var Select = Controls.Select,
  Text = Controls.Text;
var styles = {
  wrapper: 'mb-3'
};
var taxNumberValid = function taxNumberValid(val) {
  return cpfIsValid(val) || cnpjIsValid(val);
};
export var initialState = {
  taxIdentification: {
    number: '',
    type: ''
  }
};
var TaxIdentificationForm = function TaxIdentificationForm(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(T, {
    source: "Tax Identification"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-12"
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Tax Type",
    messages: {
      notEmpty: 'Please select your tax type.'
    },
    name: "".concat(name, "[taxIdentification][type]"),
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    options: [{
      value: 'CPF',
      label: 'CPF'
    }, {
      value: 'CNPJ',
      label: 'CNPJ'
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Tax Number",
    messages: {
      taxNumberValid: 'Please enter your tax number.'
    },
    name: "".concat(name, "[taxIdentification][number]"),
    validators: {
      taxNumberValid: taxNumberValid
    },
    styles: styles
  })));
};
export default TaxIdentificationForm;